import ErrorIcon from "@/components/_icons/errorIcon";

export const ErrorBanner = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => {
  return (
    <div
      className={
        "rounded-lg mx-3 bg-[#FFEDED] border border-[#E70000] p-3 flex items-start gap-4 " +
        className
      }
    >
      <ErrorIcon width={24} height={24} />
      <span className="text-base">{text}</span>
    </div>
  );
};
